import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login.service';
import { environment } from 'environments/environment';
import { HeaderFacadeService } from './header-facade.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class AppHeaderComponent {
  public nombre: string;
  public layaoutExit: boolean;

  constructor(private _route: Router, public _headerFacade: HeaderFacadeService, public loginService: LoginService) {
    this.nombre = localStorage.getItem('nombre');
    if (localStorage.getItem(environment.tokenLocal)) {
      this.layaoutExit = true;
    }
  }

  salir() {
    this.loginService.cerrarSesion();
    this._route.navigateByUrl('/inicio');
  }

}
